<template>
        <div class="app-Recharge">
            <div class="ccpay-Recharge-header">
                <span @click="back"> 退後</span>
                <span >充值</span>
                <span></span>
             </div>
             <div class="cpay-Recharge-connect">
                 <div class="cpay-Recharge-tab">
                    <!--  <div :class="isactive==1?'active':''" @click="tabactive(1)">ERC-20协议</div>
                    <div :class="isactive==2?'active':''" @click="tabactive(2)">OMNI Layer协议</div> -->
                    <div :class="isactive ? 'active' : ''" >
                    TRC-20协议
                    </div>
                 </div>
                 <div class="cpay-Recharge-address">
                     <p style="margin-bottom:1rem;line-height: 1.5rem;">充币地址：{{address}}
                     <span   class="tag-read" :data-clipboard-text="address" 
                             style="color:#20ABFE" @click="copy">复制</span>
                     </p>
                     <p style="text-align:center"> 
                         <img style="width:150px;height:150px;object-fit: contain;" 
                         v-lazy="`data:image/png;base64,${qrcode&&qrcode}`"
                         :src="`data:image/png;base64,${qrcode&&qrcode}`"
                         /></p>
                 </div>
                 <div class="cpay-Recharge-msg">
                     <p>提示</p>
                     
                      <p> 1、最小存币金额为10,000.00USDT</p>

                      <p>  2、预计到账時間为10-60分钟，如需快速到账，您可向USDT网络支付适當矿工费</p>

                      <p> 3、您的USDT地址不会无故更改，可重复存币</p>

                      <p>  4、请务必确认电脑及浏览器安全，防止資訊被篡改或泄露</p>
                      
                      <p> 如有疑问，请联系客服</p>
                 </div>
             </div>
        </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Indicator } from 'mint-ui';
export default {
    data(){
        return{
            isactive: true,
            address:'',
            qrcode:'',

            addresseth:'',
            qrcodeeth:'',

            addressomn:'',
            qrcodeomn:'',

            addressTRX:'',
            qrcodeTRX:'',
            etcflag:false
        }
    },
    mounted(){
       // this.getUSDT1()
       // this.getUSDT2()
       this.getUSDT3()
    },
    methods:{
        back(){
            this.$router.go(-1)
        },
        getUSDT1(){
            Indicator.open();
           this.$axios.get('/v1/wallet/usdt/get_address?symbol=ETH_USDT').then(res=>{
                Indicator.close();
                if(res.code==0){
                    this.address = res.data.address
                    this.qrcode = res.data.qrcode
                    this.addresseth = res.data.address
                    this.qrcodeeth = res.data.qrcode
                }
            })
        },
        getUSDT2(){
            // Indicator.open();
            this.$axios.get('/v1/wallet/usdt/get_traders_init_address').then(res=>{
                //  Indicator.close();
                if(res.code==0){
                    // this.address = res.data.address
                    // this.qrcode = res.data.qrcode
                    this.addressomn = res.data.address
                    this.qrcodeomn = res.data.qrcode
                }
            })
        },
        getUSDT3(){
            this.$axios.get('/v1/wallet/usdt/get_address?symbol=TRX').then(res=>{
                if(res.code==0){
                    this.address = res.data.address
                    this.qrcode = res.data.qrcode
                    this.addressTRX = res.data.address
                    this.qrcodeTRX = res.data.qrcode
                }
            })
        },
        tabactive(type){

            this.isactive = type
            if(this.isactive==1){
                 this.address = this.addresseth
                 this.qrcode =   this.qrcodeeth
                // this.getUSDT1()
            }else if(this.isactive==2){
                // this.getUSDT2()
                this.address = this.addressomn
                 this.qrcode =   this.qrcodeomn
            }else{
                this.address = this.addressTRX
                 this.qrcode =   this.qrcodeTRX
            }
        },
        copy(){
            var clipboard = new Clipboard('.tag-read')
                clipboard.on('success', e => {
        //           console.log('复制成功')
                    this.$Toast('复制成功')
                  // 释放内存
                  clipboard.destroy()
                })
                clipboard.on('error', e => {
                  // 不支持复制
         this.$Toast('该浏览器不支持自动复制')
        //           console.log('该浏览器不支持自动复制')
                  // 释放内存
                  clipboard.destroy()
                })
        },
    }
}
</script>

<style lang="scss" scoped>
    .app-Recharge{
          height: 100%;;
          background: white;
        .ccpay-Recharge-header{
                background: white;
                display: flex;
                justify-content: space-between;
                padding: 1rem;
          
        }
        .cpay-Recharge-connect{
             background: white;
            padding: 1rem;
        }
        .cpay-Recharge-address{
             margin-bottom: 1rem;
        }
        .cpay-Recharge-tab{
            font-size: 14px;
             background: white;
            display: flex;
            justify-content: space-around;
            margin-bottom: 2rem;
            div{
                padding-bottom: 1rem;
            }
            .active{
                color: #20ABFE;
                 border-bottom: 1px solid #20ABFE;
            }
        }
        .cpay-Recharge-msg{
            p{
                line-height: 2rem;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/my/Recharge.vue